import { ReactNode } from 'react'

import Box, { BoxProps } from 'app/components/base/Box'
import Stack, { StackProps } from 'app/components/base/Stack'
import theme from 'app/theme/dripsy'

interface BorderGradientProps extends StackProps {
  children: ReactNode
  sx?: BoxProps['sx']
  sxContent?: StackProps['sx']
  startColor?: string
  lastColor?: string
  borderRadius?: number
  borderWidth?: string | number
  withoutGradient?: boolean
  dataTestId?: string
}

const LinearGradientBorderContainer: RFC<BorderGradientProps> = ({
  children,
  sx,
  sxContent,
  startColor = theme.colors['secondary.light'],
  lastColor = theme.colors['secondary.main'],
  borderRadius = 2,
  borderWidth = '1px',
  withoutGradient,
  dataTestId,
  ...props
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        p: borderWidth,
        borderRadius,
        background: !withoutGradient
          ? `linear-gradient(#fff, #fff) padding-box,linear-gradient(90deg, ${startColor}, ${lastColor}) border-box`
          : 'transparent',
        border: '1px solid transparent',
        overflow: 'hidden',
        ...sx
      }}
    >
      <Stack
        data-testid={dataTestId}
        sx={{
          borderRadius,
          position: 'relative',
          width: '100%',
          display: 'flex',
          p: 2,
          ...sxContent
        }}
        {...props}
      >
        {children}
      </Stack>
    </Box>
  )
}

export default LinearGradientBorderContainer
